import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import { ActionButton } from '../components/ActionButton';
import DivContainer from '../components/DivContainer';
import InputTextComponent from '../components/inputs/InputTextComponent';
import PublicHolidaysService from '../services/PublicHolidaysService';
import InputCalendarComponent from '../components/inputs/InputCalendarComponent';

class PublicHolidayCreateDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new PublicHolidaysService());
        this.state = {
            elementId: props.elementId,
            element: {
                name: '',
                choosenDay: undefined
            },

            filteredEmployees: [],
           // viewMode: this.props.viewMode,
            viewMode: 'NEW'
        };
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    prepareFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <div className='left-footer-dialog-button-container'></div>
                <ActionButton
                    id={'ph-cancel-button'}
                    label={t('details.cancel')}
                    variant={'button cancel-button white'}
                    handleClick={(e) => {
                        this.props.onHide(undefined);
                    }}
                />
                <ActionButton
                    id={'ph-save-button'}
                    label={ t('details.saveChanges')}
                    variant='button save-button blue'
                    handleClick={this.handleFormSubmit}
                    //rendered={true}
                />
            </div>
        );
    }

    searchEmployees(query) {
        this.employeeService
            .search(query, null, 'ACTIVE')
            .then((filteredEmployees) => this.setState({filteredEmployees: filteredEmployees}))
            .catch(() => {
                this.showErrorMessage('Nie udało się pobrać listy pracowników');
            });
    }

    renderHeader() {
        const {t} = this.props;
        return (
            <DivContainer colClass='col-12'>
                <DivContainer colClass='col-12'>
                    <label>
                        {/* {this.props.viewMode === 'NEW'
                            ? `${t('public-holidays.addHeader')}` : null} */}
                            {`${t('public-holidays.addHeader')}`}
                    </label>
                </DivContainer>
            </DivContainer>
        );
    }
    updateElement(data) {
        this.setState(
            {
                element: data,
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }
    setElement() {
        if (this.props.element) {
            this.updateElement(this.props.element);
        }
    }

    getAddSucces() {
        const {t} = this.props;
        return t('public-holidays.addSuccess');
    }

    getUpdateSucces() {
        const {t} = this.props;
        return t('public-holidays.updateSuccess');
    }
    createOrUpdate() {
        const {element} = this.state;
        this.scrollToTop();
        if (this.props._isMounted) {
                this.service
                    .add(element)
                    .then((response) => {
                        this.blockUi();
                        this.persistMessage('success', '', this.getAddSucces(response));
                        if (this.props.afterSave) {
                            this.props.afterSave();
                        }
                    })
                    .catch((err) => {
                        this.showErrorMessage(err.message);
                        this.unblockUi();
                    });
        }
    }

    renderDetails() {
        const {t} = this.props;
        const {element} = this.state;
           
        return (
            <React.Fragment>
                <DivContainer colClass='row'>
                     <InputCalendarComponent
                        key={'public-holiday-date'}
                        id='public-holiday-date'
                        name='date'
                        label={t('public-holidays.date')}
                        colClass='col-md-4'
                        value={element.date}
                        validator={this.validator}
                        validators='required'
                        onChange={this.handleChange}
                        viewMode={'VIEW'}
                        dateFormatMoment='DD-MM-YYYY'
                        />
                    <InputTextComponent
                            id='public-holiday-name'
                            name='name'
                            label={t('public-holidays.name')}
                            colClass='col-md-8'
                            value={this.state.element.name}

                            validator={this.validator}
                            validators='required|max:30'
                            onChange={this.handleChange}
                            viewMode={'NEW'}
                        />
                </DivContainer>
            </React.Fragment>
        );
    }
}

PublicHolidayCreateDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'NEW',
    visible: false,
    stationId: undefined,
};

PublicHolidayCreateDialog.propTypes = {
    backUrl: PropTypes.string,
    cancelUrl: PropTypes.string,
    currentUser: PropTypes.object,
    editUrl: PropTypes.string,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    elementId: PropTypes.number,
    stationId: PropTypes.number,
    roleTypes: PropTypes.object,
    className: PropTypes.string,
};

export default withTranslation()(PublicHolidayCreateDialog);
